import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=2d28ab80&scoped=true"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=2d28ab80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d28ab80",
  null
  
)

export default component.exports